import { useContext, useEffect, useState } from "react";
import styled from "styled-components";
import { PageContext } from "../../../../Context/PageContext";
import { ApiConnectHistoricLog, ApiConnectVipRequestLog } from "../../../../api/LionsUserApiConect";
import StarIcon from "../meucadastro/img/processando.png"
import WaitingIcon from "../meucadastro/img/processando.png"
import RejectedIcon from "../meucadastro/img/red-check.png"
import AprovedIcon from "../meucadastro/img/green-check.png"
import UserNotLogged from "../UserNotLogged";
import { MobTipMouseOutEvent, MobTipMouseOverEvent } from "../../../Database/MobShowToolTip";


function VipRequestLog() {

    const { user, setPage, setIsLogged, setToolTipContent } = useContext(PageContext);

    const [vipLogList, setVipLogList] = useState([])
    const [dateRule, setDateRule] = useState("-")
    const [topicRule, setTopicRule] = useState("")

    useEffect(() => {
        let result = ApiConnectVipRequestLog(user.userName, user.userEmail)
        result.then(response => {

            if(response.status == 403 || response.status == 401) {
                setPage(<UserNotLogged />);
                setIsLogged(false);
                return;
            }
            if(response.data == false){
                setVipLogList([]);
                setTimeout(() => document.getElementById("Master").style.opacity = 1,300)
                return;
            }
            setTimeout(() => document.getElementById("Master").style.opacity = 1,300)
            setVipLogList(response.data)});
        }
        ,[])

    return(
        <HistoricContainer id="Master">
                <TitleMaster>
                    <ColumItemHeaderIcon iconImg={StarIcon}/>
                    <TitleFont>Histórico de Solicitações</TitleFont>
                </TitleMaster>
                <HistoricHeader>
    
                    <HistoricHeaderItem>
                        <Select onChange={(e) => setDateRule(e.target.value)}>
                            <Option value="-">Data de Atualização</Option>
                            <Option value="2024">2024</Option>
                            <Option value="2025">2025</Option>
                        </Select>
                        </HistoricHeaderItem>

                        <HistoricHeaderItem>
                        <Select onChange={(e) => setTopicRule(e.target.value)}>
                            <Option value="">Situação</Option>
                            <Option value="Aguardando Pagamento">Aguardando</Option>
                            <Option value="Aprovado">Aprovado</Option>
                            <Option value="Reje">Reijeitado</Option>
                            <Option value="Proces">Processando</Option>
                        </Select>
                    </HistoricHeaderItem>

                </HistoricHeader>

                <HistoricItemsMaster>
                    {vipLogList.map((item) => {
                        if(item.requestStatus.includes(topicRule) == false){
                            return;
                        }
                        if(item.eventDate.includes(dateRule) == false){
                            return;
                        }

                        let iconImage = ""

                        if(item.requestStatus.includes("Aguardando")) { iconImage = WaitingIcon} else 
                        if(item.requestStatus.includes("Proces")) { iconImage = WaitingIcon} else 
                        if(item.requestStatus.includes("Reje")) { iconImage = RejectedIcon} else 
                        if(item.requestStatus.includes("Aprovado")) { iconImage = AprovedIcon }

                        return(
                        <HistoricItem
                            onMouseOver={(event) => {
                                setToolTipContent(
                                    <HistoricTipContainer>
                                        <HistoricField>Acesso: {item.userId}</HistoricField>
                                        <HistoricFieldPlan>Plano Escolhido: {item.planName}</HistoricFieldPlan>
                                        <HistoricFieldDate>Data: {item.eventDate}</HistoricFieldDate>
                                    </HistoricTipContainer>)
                                MobTipMouseOverEvent(event, `Relatório de acesso`, "rgba(0,0,0,1)")
                            }}
                                  
                            onMouseLeave={() => MobTipMouseOutEvent()}>
                        
                            <HistoricFieldNumber>{item.requestCode} </HistoricFieldNumber>
                            <HistoricFieldStatus>{item.requestStatus} <VipRequestStatusIcon iconImg={iconImage}/></HistoricFieldStatus>
                        </HistoricItem>
                        )
                    })}

                </HistoricItemsMaster>
                </HistoricContainer>

    )
}

export default VipRequestLog;

const HistoricContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    width: 100%;
    //border: solid;
    border-radius: 10px;
    //box-shadow: 0 0 10px 0 black;
    padding: 0px 0px;
    max-height: 800px;
    transition: .5s ease-in-out;
    opacity: 0;

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 40px 15px;
      //border: solid 1px rgba(0,0,0, .2);
    }

`

const TitleMaster = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    width: 100%;
    border-radius: 10px;
    transition: .3s ease-in-out;
    margin: 30px 0;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      width: 90vw;
      padding: 0 0px;
    }

`

const TitleFont = styled.span`
    font-size: 24pt;
    font-weight: bold;
    margin: 25px 0;

    @media(max-width: 1000px) {
      font-size: 20pt
    }

`

const ColumItemHeaderIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 45px;
    height: 45px;
    margin: 0 55px;
    //border: solid;

    @media(max-width: 1000px) {
        width: 35px;
        height: 35px;
        margin: 0 20px;
    }

    
`

const HistoricHeader = styled.div`
    display: flex;
    align-items: center;
    justify-content: start;
    padding: 0px 0px;
    width: 100%;
    margin: 10px 0;
    /border: solid;
    //background-color: rgba(0,0,0,.7);

    @media(max-width: 1000px) {
        margin-bottom: 20px;
    }

`

const HistoricHeaderItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: bold;
    font-size: 12pt;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    margin: 0 25px 0 0;
    border-radius: 5px;
    background-color: rgba(0,0,0,.7);
    color: white;
    width: 200px;

    @media(max-width: 1000px) {
      font-size: 12pt;
    }

`

const HistoricItemsMaster = styled.div`
    display: flex:
    flex-direction: column;
    align-items: center;
    //border: solid;
    background-color: rgba(0,0,0,.7);
    margin: 10px 0;
    border-radius: 5px;
    width: 100%;
    margin-top: 30px;
    overflow: auto;
    padding: 5px 0;

    
`
const HistoricItem = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 12pt;
    transition: .3s ease-in-out;
    cursor: pointer;
    background-color: rgba(0,0,0,.7);
    border-radius: 5px;
    margin: 5px 10px;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    &:hover{
    background-color: rgb(32, 106, 151);
    color: white;
    }
`

const HistoricTipContainer = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    //justify-content: space-between;
    font-size: 12pt;
    transition: .3s ease-in-out;
    cursor: pointer;
    background-color: rgba(0,0,0,1);
    border-radius: 5px;
    margin: 5px 10px;
    padding: 10px 0;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }
`

const HistoricField = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    text-align: center;
    //border: solid;
    color: white;
    margin: 5px 5px;
    width: 200px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 5px;

    @media(max-width: 1000px) {
      font-size: 8pt;
    }

`
const HistoricFieldNumber = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    text-align: center;
    //border: solid;
    color: white;
    margin: 10px 5px;
    width: 130px;

    @media(max-width: 1000px) {
      font-size: 8pt;
      width: 200px;
    }

`
const HistoricFieldPlan = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    text-align: center;
    //border: solid;
    color: white;
    margin: 5px 5px;
    width: 200px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 5px;

    @media(max-width: 1000px) {
      font-size: 8pt;
      width: 200px;
    }

`
const HistoricFieldDate = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    text-align: center;
    //border: solid;
    color: white;
    margin: 5px 15px;
    width: 200px;
    background-color: rgba(255, 255, 255, 0.3);
    border-radius: 5px;

    @media(max-width: 1000px) {
      font-size: 8pt;
      width: 200px;
    }

`
const HistoricFieldStatus = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
    transition: .3s ease-in-out;
    padding: 10px 0px;
    text-align: center;
    //border: solid;
    color: white;
    margin: 0px 5px;
    width: 220px;

    @media(max-width: 1000px) {
      font-size: 8pt;
      width: 200px;
    }

`

const VipRequestStatusIcon = styled.div`
    background-image: url(${props => props.iconImg});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 20px;
    height: 20px;
    margin-left: 25px;

    @media(max-width: 1000px) {
      width: 20px;
      height: 20px
      margin-left: 0px;
    }
`

const Select = styled.select`
    border: none;
    display: flex;
    align-items: center;
    text-align: center;
    justify-content: center;
    padding: 2px 5px;
    font-size: 12pt;
    transition: .3s ease-in-out;
    width: 100%;
    font-weight: bold;
    background-color: transparent;
    color: white;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
    }

    @media(max-width: 1000px) {
      font-size: 10pt;
    }
`
const Option = styled.option`
    background-color: rgba(0,0,0,.7);
    color: white;
    
`



